import { render, staticRenderFns } from "./print-pieces.vue?vue&type=template&id=04df0549&scoped=true"
import script from "./print-pieces.vue?vue&type=script&lang=js"
export * from "./print-pieces.vue?vue&type=script&lang=js"
import style0 from "./print-pieces.vue?vue&type=style&index=0&id=04df0549&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04df0549",
  null
  
)

export default component.exports